import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import './App.css';

import Navbar from './Components/Navbar/Navbar';
import Hero from './Components/Hero/Hero';
import HeroIntro from './Components/HeroIntro/HeroIntro';
import ProductCategory from './Components/ProductCategory/ProductCategory';
import MissionVision from './Components/MissionVision/MissionVision';
import WhyChooseHKI from './Components/WhyChooseHKI/WhyChooseHKI';
import IndustriesWeServe from './Components/IndustriesWeServe/IndustriesWeServe';
import Footer from './Components/Footer/Footer';
import DemoProductPage from './Components/DemoProductPage/DemoProductPage';
import ProductDetail from './Components/ProductDetail/ProductDetail';
import Contact from './Components/Contact/Contact';
import AboutUs from './Components/AboutUs/AboutUs';
import Certificates from './Components/Certificates/Certificates';
import NewsBlogs from './Components/NewsBlogs/NewsBlogs';
import NewsDetail from './Components/NewsBlogs/NewsDetail';
import Inquiry from './Components/Inquiry/Inquiry';
import Catalog from './Components/Catalog/Catalog';
import CatalogConfirmation from './Components/Catalog/CatalogConfirmation';
import SearchResults from './Components/SearchResults/SearchResults';
import NotFound from './Components/NotFound/NotFound';
import { SiteContentProvider } from './context/SiteContentContext';

function PageFrame({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <Navbar />
      {children}
      <Footer />
    </motion.div>
  );
}

function HomePage() {
  return (
    <PageFrame>
      <Hero />
      <HeroIntro />
      <ProductCategory />
      <MissionVision />
      <WhyChooseHKI />
      <IndustriesWeServe />
    </PageFrame>
  );
}

function ProductsPage() {
  return (
    <PageFrame>
      <DemoProductPage />
    </PageFrame>
  );
}

function ProductDetailPage() {
  return (
    <PageFrame>
      <ProductDetail />
    </PageFrame>
  );
}

function ContactPage() {
  return (
    <PageFrame>
      <Contact />
    </PageFrame>
  );
}

function AboutUsPage() {
  return (
    <PageFrame>
      <AboutUs />
    </PageFrame>
  );
}

function CertificatesPage() {
  return (
    <PageFrame>
      <Certificates />
    </PageFrame>
  );
}

function NewsBlogsPage() {
  return (
    <PageFrame>
      <NewsBlogs />
    </PageFrame>
  );
}

function NewsDetailPage() {
  return (
    <PageFrame>
      <NewsDetail />
    </PageFrame>
  );
}

function InquiryPage() {
  return (
    <PageFrame>
      <Inquiry />
    </PageFrame>
  );
}

function CatalogPage() {
  return (
    <PageFrame>
      <Catalog />
    </PageFrame>
  );
}

function CatalogConfirmationPage() {
  return (
    <PageFrame>
      <CatalogConfirmation />
    </PageFrame>
  );
}

function SearchResultsPage() {
  return (
    <PageFrame>
      <SearchResults />
    </PageFrame>
  );
}

function App() {
  return (
    <SiteContentProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/product/:productSlug" element={<ProductDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/certificates" element={<CertificatesPage />} />
            <Route path="/news-blogs" element={<NewsBlogsPage />} />
            <Route path="/news-blogs/:id" element={<NewsDetailPage />} />
            <Route path="/inquiry" element={<InquiryPage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/catalog-confirmation" element={<CatalogConfirmationPage />} />
            <Route path="/search" element={<SearchResultsPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </SiteContentProvider>
  );
}

export default App;
